module.exports = __webpack_public_path__ + "static/img/areaB_1.d08ecfa.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_1.png
// module id = 1271
// module chunks = 1